
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABmUExURQAAAP////////////////////////////////// //////j4+8zU48XO3+Lm79TZ55KjxIudwKi10Pj5+/Dy99Pa56+706i1z+ns86i20Nvg6+Ln777I 3JqpyNTa5+nt8/Hz9wAAAMXV30YAAAAKdFJOUwBAj9/PnyAQkD+yeUh8AAAAAWJLR0QAiAUdSAAA AAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMBAM5IyOiuV0AAADISURBVCjPhdLbEkMwEIDh FcduBUtKU6V9/6csghwk0//K+CZjshZgKWIxWiVpBqq8QE8s3yxBb8mqBQZiABkGiyANIwPji/eS VybGoJ/rhojazlCNYjUi7sXHZtR4kSsk0Q/D08VKmeyklC8Xsd1wRMG5uGD3nkiOiDPRfEF93+O2 Jy4TUFXYU2lj3dBR+xk7C4U2Yw5gTcCZA9gTUDk4mzaduK/WzHXf3RJg4Z+dQhTGZT2DR9m/1YTc e1Yt9VKWOqdjdlvf/wCxFiGLe4sAOAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0wNFQwMjoz MjoxMSswMDowMGeQst8AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6MTIrMDA6 MDAnJRD+AAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM1KzAwOjAwJLjQ UAAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    